import React, { useState } from 'react';
import {
  Box,
  Text,
  SimpleGrid,
  VStack,
  HStack,
  Avatar,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Select,
  Divider,
  Icon,
  Badge,
  Center,
  Spacer,
  Image,
  Flex,

} from '@chakra-ui/react';
import { ChevronDownIcon, CheckIcon, InfoIcon, CloseIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion'; // For animations
import dayjs from 'dayjs';
import pendingImg from '../../assets/pending.svg';
import doneImg from '../../assets/success-green-check-mark-icon.png';

const DynamicCalendar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [selectedDay, setSelectedDay] = useState(null);

  const daysInMonth = currentDate.daysInMonth();
  const firstDayOfMonth = currentDate.startOf('month').day();

  const days = [
    { date: 2, status: 'Pending', title: 'Nursing', Vendor:'Dr.xyz' , location: 'Mumbai'},
    { date: 5, status: 'Done', title: 'Nursing', Vendor:'Dr.abc', location: 'Delhi'},
    { date: 11, status: 'Pending', title: 'Nursing', Vendor:'Dr.mno', location: 'Kolkata'},
    { date: 30, status: 'Done', title: 'Nursing', Vendor:'Dr.pqr', location: 'Bangalore'},
  ];

  const months = Array.from({ length: 12 }, (_, i) =>
    dayjs().month(i).format('MMMM')
  );

  const years = Array.from({ length: 10 }, (_, i) =>
    dayjs().year() - 5 + i
  );

  const handleMonthChange = (e) => {
    setCurrentDate(currentDate.month(months.indexOf(e.target.value)));
  };

  const handleYearChange = (e) => {
    setCurrentDate(currentDate.year(Number(e.target.value)));
  };

  const handleDayClick = (day) => {
    setSelectedDay(day);
    onOpen();
  };

  const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
return (
    <Box p={10} pt={20} maxW="100%" mx="auto" bg="white" minH="100vh">
      <HStack justifyContent="space-between" mb={4}>
        <Text fontSize={['lg', 'xl', '2xl']} fontWeight="bold"> {/* Responsive font size */}
          My Calendar
        </Text>
        <HStack spacing={4}>
          <Select
            value={currentDate.format('MMMM')}
            onChange={handleMonthChange}
            icon={<ChevronDownIcon />}
            width="150px"
            variant="outline"
            borderColor="black"
          >
            {months.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </Select>
          <Select
            value={currentDate.year()}
            onChange={handleYearChange}
            icon={<ChevronDownIcon />}
            width="100px"
            variant="outline"
            borderColor="black"
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Select>
        </HStack>
      </HStack>
  
      <Box borderWidth="1px" borderRadius="lg" p={2} bg="white" boxShadow="md">
        <SimpleGrid columns={7} spacing={2}>
          {dayNames.map((dayName) => (
            <Box key={dayName} textAlign="center" color="gray.500">
              {dayName}
            </Box>
          ))}
          {Array.from({ length: firstDayOfMonth }).map((_, i) => (
            <Box key={`empty-${i}`} />
          ))}
          {Array.from({ length: daysInMonth }, (_, i) => {
            const day = days.find((d) => d.date === i + 1);
            return (
              <motion.div
                key={i}
                whileHover={{ scale: 1.05 }} // Add hover animation
                transition={{ duration: 0.2 }} // Animation duration
              >
                <Box
                  bg={day ? (day.status === 'Pending' ? 'yellow.100' : 'teal.50') : 'gray.50'} // Change color based on status
                  p={2}
                  borderRadius="md"
                  onClick={day ? () => handleDayClick(day) : undefined}
                  cursor={day ? 'pointer' : 'default'}
                  height="80px"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Text fontSize={['sm', 'md', 'lg']}>{i + 1}</Text> {/* Responsive font size */}
                  {day && (
                    <Badge
                      fontSize={['xx-small', 'xs', 'sm']} // Reduced font size for better fit
                      colorScheme={day.status === 'Pending' ? 'yellow' : 'green'}
                      mt={1}
                      p={[0.5, 1]} // Adjusted padding for better fit
                      borderRadius="full" // Rounded badge
                    >
                      {day.status}
                    </Badge>
                  )}
                </Box>
              </motion.div>
            );
          })}
        </SimpleGrid>
      </Box>
  
      {/* Square Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent
          as={motion.div}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ duration: 0.4 }}
          bg="white"
          borderRadius="xl"
          width="300px"
          height="400px"
          boxShadow="2xl"
          margin="auto"
          display="flex"
          flexDirection="column"
          justifyContent="space-between" // Ensures content is spaced between top and bottom
        >

<ModalHeader textAlign="center" mt={4}>
  <Flex justifyContent="center" alignItems="center">
    {selectedDay?.status === 'Pending' ? (
      <Image
        src={pendingImg} // Use the imported image
        alt="Pending"
        boxSize="40px" // Increased size
        mr={2}
         
      />
    ) : (
      <Image
        src={doneImg} // Use the imported image
        alt="Done"
        boxSize="40px" // Increased size
        mr={2}
        
      />
    )}
   
      

  </Flex>
</ModalHeader>

          <ModalCloseButton position="absolute" top="8px" right="8px" />

<ModalBody flex="1" display="flex" alignItems="center" justifyContent="center">
  <Center height="100%">
    <VStack spacing={4} align="center">
      <Text fontSize={['sm', 'md']} color="gray.600"> {/* Responsive font size */}
        Job Details for{' '}
        <Text as="span" fontWeight="bold">
          {currentDate.format('MMMM')} {selectedDay?.date}
        </Text>
      </Text>
      <Divider />
      <SimpleGrid columns={2} spacing={4} width="100%"> {/* Use SimpleGrid for alignment */}
        <Text fontWeight="bold" fontSize={['xs', 'sm']} textAlign="right">Title :</Text>
        <Text fontSize={['xs', 'sm']} color="gray.600">{selectedDay?.title}</Text>
        
        <Text fontWeight="bold" fontSize={['xs', 'sm']} textAlign="right">Vendor :</Text>
        <Text fontSize={['xs', 'sm']} color="gray.600">{selectedDay?.Vendor}</Text>
        
        <Text fontWeight="bold" fontSize={['xs', 'sm']} textAlign="right">Location :</Text>
        <Text fontSize={['xs', 'sm']} color="gray.600">{selectedDay?.location}</Text>
        
        <Text fontWeight="bold" fontSize={['xs', 'sm']} textAlign="right">Status :</Text>
        <Text fontSize={['xs', 'sm']} color={selectedDay?.status === 'Pending' ? 'yellow.600' : 'green.600'}>
          {selectedDay?.status}
        </Text>
      </SimpleGrid>
    </VStack>
  </Center>
</ModalBody>



          <ModalFooter justifyContent="center" mt={4}>
            <HStack spacing={4} pb={4}> {/* Added padding-bottom */}
              <Button
                colorScheme="blue"
                leftIcon={<CheckIcon />}
                style={{ backgroundColor: 'blue', color: 'white' }}
                onClick={onClose}
                height={10}
                width={20}
                size="lg"
                p={4} // Added padding to the button
              >
                Done
              </Button>
              <Button
                colorScheme="gray" // Changed color scheme to gray
                leftIcon={<CloseIcon />}
                style={{ backgroundColor: 'red', color: 'white' }} // Updated color to gray
                onClick={onClose}
                height={10}
                width={20}
                size="lg"
                p={4} // Added padding to the button
              >
                Close
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
  
  // ... existing code ...
  // ... existing code ...
  
  // ... existing code ...
  
  // ... existing code ...
  // ... existing code ...

  


  
};

export default DynamicCalendar;